import axios, { AxiosRequestConfig } from "axios";

import getErrorDetails from "../../../api/helpers/getErrorDetails";
import {
  getPaginationInfoFromHeaders,
  PaginatedList,
} from "../../../api/helpers/pagination";
import { DEFAULT_PAGINATION } from "../../../constants/defaultPagination";
import { CM_CONFIGURABLE_PROVIDERS } from "../constants/Provider";

import type { UUID } from "../../../utils";
import type {
  CashManagementProvider,
  CashManagementProviderCurrencies,
} from "../models/Provider";

export type GetCashManagementsProviders = (
  options?: AxiosRequestConfig
) => Promise<PaginatedList<CashManagementProvider>>;

export type GetCashManagementProvider = (
  id: UUID,
  options?: AxiosRequestConfig
) => Promise<CashManagementProvider>;

export type GetSupportedCurrencies = (
  options?: AxiosRequestConfig
) => Promise<CashManagementProviderCurrencies>;

export type GetCashManagementConfigurableProviders = (
  options?: AxiosRequestConfig
) => Promise<PaginatedList<CashManagementProvider>>;

export const getCashManagementProviders: GetCashManagementsProviders = async (
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/cash-management/providers`,
    });
    const { data = {}, headers: responseHeaders = {} } = response;

    const {
      totalItems,
      currentPage,
      currentLimit,
    } = getPaginationInfoFromHeaders(responseHeaders);

    return {
      list: data || [],
      totalItems,
      currentPage,
      currentLimit,
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const getSupportedCurrencies: GetSupportedCurrencies = async (
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: "/cash-management/currencies",
      params: DEFAULT_PAGINATION,
    });
    const { data = {} } = response;

    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};

// TODO refactor after endpoint created
// Just mocked because currently there is only two providers that need config and there is not any endpoint to retrieve that
export const getCashManagementConfigurableProviders: GetCashManagementConfigurableProviders = async (
  options
) => {
  try {
    let providers = await getCashManagementProviders(options);

    return {
      ...providers,
      list: providers.list.filter((provider) =>
        CM_CONFIGURABLE_PROVIDERS.includes(provider.name)
      ),
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
};
